var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.href && !_vm.route
    ? _c(
        "button",
        {
          class: _vm.btnClass,
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.onClick },
        },
        [_vm._t("default")],
        2
      )
    : _vm.disabled && (_vm.href || _vm.route)
    ? _c(
        "button",
        { class: _vm.btnClass, attrs: { disabled: _vm.disabled } },
        [_vm._t("default")],
        2
      )
    : !_vm.href && _vm.route
    ? _c("router-link", { class: _vm.btnClass, attrs: { to: _vm.route } }, [
        _c("span", { on: { click: _vm.onClick } }, [_vm._t("default")], 2),
      ])
    : _vm.href && _vm.target !== "internal"
    ? _c(
        "a",
        {
          class: _vm.btnClass,
          attrs: { href: _vm.href, target: _vm.target },
          on: { click: _vm.onClick },
        },
        [_vm._t("default")],
        2
      )
    : _vm.href
    ? _c(
        "a",
        {
          class: _vm.btnClass,
          attrs: { href: _vm.href },
          on: { click: _vm.onClick },
        },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }